// extracted by mini-css-extract-plugin
module.exports = {"live-text":"liveText-m__live-text__3AdkT","open-blog":"liveText-m__open-blog__1VE8P","blink":"liveText-m__blink__zFH8J"};